import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/views/programs/images/facebook.png'
import _imports_1 from '@/views/programs/images/twitter.png'
import _imports_2 from '@/assets/icon/kakaotalk.png'


const _withScopeId = n => (_pushScopeId("data-v-3e5e2443"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "social-share" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0
}, null, -1))
const _hoisted_3 = { class: "text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_1
}, null, -1))
const _hoisted_5 = { class: "text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_2
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

import { kakaoShare, lineShare, facebookShare, twitterShare } from '@/utils';
  import { useI18n } from 'vue-i18n';

  // 和 import type { IKakaoShare } from '@/utils/social-share' 一样
  // https://github.com/vuejs/core/issues/4294
  interface IProps {
    title: string;
    description?: string;
    imageUrl?: string;
    link?: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    title: { default: document.title },
    description: null,
    imageUrl: null,
    link: null
  },
  setup(__props: any) {

const props = __props as { title: string, description?: string, imageUrl?: string, link?: string }

  

  const { t, locale } = useI18n();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "item facebook",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(facebookShare)(props.link)))
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('shareText')), 1)
    ]),
    _createElementVNode("div", {
      class: "item twitter",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(twitterShare)(props.link, props.title)))
    }, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('shareText')), 1)
    ]),
    (_unref(locale) === 'ja')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "item line",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(lineShare)(props.link)))
        }))
      : _createCommentVNode("", true),
    (_unref(locale) === 'ko')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "item kakao",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(kakaoShare)(props)))
        }, _hoisted_7))
      : _createCommentVNode("", true)
  ]))
}
}

})